module.exports = __webpack_public_path__ + "assets/img/1.9f7835f6.png";